//@flow
import * as Immutable from 'immutable';

import { VisitSlot } from 'common/models/flow/VisitSlot';
import type { VisitSlotModelType } from 'common/models/flow/VisitSlot';
import moment from 'moment-timezone';
import TimeUtils from 'common/utils/TimeUtils';

class InternalVisitSlot extends VisitSlot {
    static fromJS(json: VisitSlotModelType): InternalVisitSlot {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    get startTime(): moment {
        return this._state.get('startTime');
    }

    get endTime(): moment {
        return this._state.get('endTime');
    }
    convertSlotToTimezone(timezone: string) {
        if (!this.startTime || !this.endTime) {
            return this;
        }
        const newSlot = this.setStartTime(
            TimeUtils.convertToTimezone(this.startTime, timezone)
        );
        return newSlot.setEndTime(
            TimeUtils.convertToTimezone(newSlot.endTime, timezone)
        );
    }

    static getVisitSlotObject({
        startTime,
        endTime,
        format
    }: {
        startTime: string,
        endTime: string,
        format: string
    }): InternalVisitSlot {
        return this.fromJS({
            startTime: moment(startTime, format),
            endTime: moment(endTime, format)
        });
    }
}

export { InternalVisitSlot as VisitSlot };
